import { useState } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import Tooltip from './Tooltip';
import emojiArray from '../../assets/emoji.json';

const EmojiPicker = ({
  onClick,
  className,
  width,
  height,
  style,
  iconColor,
  isEmoji44,
  tootipClass,
  title,
}) => {
  const { t } = useTranslation();

  const [isOpen, setOpen] = useState(false);

  const onEmojiClick = item => {
    setOpen(false);
    onClick(item);
  };
  const onClickAway = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <div className={className}>
        <Tooltip
          placement="top"
          title={title || t('chat.send-emoji')}
          detailClasses={{
            tooltipPlacementTop: tootipClass,
          }}
        >
          <span
            onClick={() => setOpen(!isOpen)}
            style={{ display: 'inline-block' }}
          >
            {isEmoji44 ? (
              <Icon id="emoji44" iconColor={iconColor} type="emoji44" />
            ) : (
              <Icon
                id="emoji"
                width={width}
                height={height}
                iconColor={iconColor}
                type="emoji"
              />
            )}
          </span>
        </Tooltip>

        <div
          style={{ ...style, display: isOpen ? 'flex' : 'none' }}
          className="emoji-container"
        >
          {emojiArray.map(item => (
            <div
              className="emoji-item"
              key={item}
              role="presentation"
              onClick={() => onEmojiClick(item)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default EmojiPicker;
